import { styled as e } from "styled-components";
import { Colors as t } from "../../../styles/colors/index.js";
import { CaptionHeavy as o } from "../../../styles/typography/index.js";
const n = e.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  padding: 4px 0;
  background-color: rgb(${t.Gray});
  border-radius: 4px;
`, l = e.p`
  ${o}
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 4px;
  color: rgb(${t.White});
`, p = e.p`
  display: flex;

  i {
    font-size: 24px;
    color: rgb(${t.White});
  }
`;
export {
  n as DealImageBadgeContainer,
  p as DealImageBadgeIcon,
  l as DealImageBadgeText
};
